import React from "react";
import { Link } from "gatsby";
var SubscriptionRequestCircle = function SubscriptionRequestCircle(_ref) {
    var _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? "#ff5b00" : _ref$backgroundColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? "white" : _ref$textColor, _ref$isMagazineOvervi = _ref.isMagazineOverview, isMagazineOverview = _ref$isMagazineOvervi === void 0 ? false : _ref$isMagazineOvervi;
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-4 md:mb-0 md:w-1/3 " + (isMagazineOverview ? "md:pl-4" : "md:pr-4")
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/abonnieren/",
        className: "block rounded-full subscribe-circle text-center text-" + textColor,
        style: {
            backgroundColor: backgroundColor
        }
    }, /*#__PURE__*/ React.createElement("strong", {
        className: "h0"
    }, "Abonnieren", /*#__PURE__*/ React.createElement("br", null), "Sie MAKROSKOP!")));
};
export default SubscriptionRequestCircle;
